import React from 'react';
import { __ } from '../../../../utils/translation-service';

export const FooterUSP = () => {
    return (
        <div className="footer_userBenefits">
            <ul className="container list-inline">
                <li className="col-xs-12 col-sm-4 text-center">
                    <div className="icon-dreamlinesPackage-expert white-rounded" />
                    <strong>{__('expert')}</strong>
                    <p className="hidden-xs">{__('expertDescription')}</p>
                </li>
                <li className="col-xs-12 col-sm-4 text-center">
                    <div className="icon-shipv2 white-rounded" />
                    <strong>{__('boardCreditsHeader')}</strong>
                    <p className="hidden-xs">
                        {`${__('boardCreditsNowUpTo')}`}&nbsp;
                        {`${__('boardCreditsPrice')}`}&nbsp;
                        {`${__('boardCreditsText')}`}
                    </p>
                </li>
                <li className="col-xs-12 col-sm-4 text-center">
                    <div className="icon-winner white-rounded" />
                    <strong>{__('bestPriceGuarantee')}</strong>
                    <p className="hidden-xs">{__('bestPriceGuaranteeDescription')}</p>
                </li>
            </ul>
        </div>
    );
};
